import {Toast} from "react-hot-toast/src/core/types";
import toast, {ToastOptions} from "react-hot-toast";
import successIcon from "././assets/svgs/ic_toast_success.svg";
import errorIcon from "./assets/svgs/ic_toast_error.svg";
import warningIcon from "./assets/svgs/ic_toast_warning.svg";
import React, {CSSProperties, ReactElement} from "react";
import {ReactComponent as CloseIcon} from "./assets/svgs/ic_input_filter_search_close.svg";
import classNames from "classnames";
import syncSpinner from "./assets/svgs/sync_spinner.svg";

const commonToastStyle: CSSProperties = {
    minWidth: "332px",
    height: "56px",
    borderRadius: "6px",
    fontSize: "18px",
    fontWeight: "normal",
    color: "#ffffff",

}

const defaultSuccessToastStyle : CSSProperties = {
    color: "#ffffff",
    backgroundColor: "#441A98",
    ...commonToastStyle
}

const defaultSuccessToastOptions: Partial<ToastOptions> = {
    icon: (
        <img src={successIcon} alt="success" width={18} height={18}/>
    ),
    duration: 4000
}

const defaultErrorToastStyle: CSSProperties = {
    backgroundColor: "#D94569",
    ...commonToastStyle
}

const defaultErrorToastOptions: Partial<ToastOptions> = {
    icon: (
        <img src={errorIcon} alt="success" width={18} height={18}/>
    ),
    duration: 4000
}

const defaultWarningToastStyle: CSSProperties = {
    backgroundColor: "#37352F",
    ...commonToastStyle
}

const defaultWarningToastOptions: Partial<ToastOptions> = {
    icon: (
        <img src={warningIcon} alt="success" width={18} height={18}/>
    ),
    duration: 4000
}

const defaultLoadingToastStyle: CSSProperties = {
    color: "#ffffff",
    backgroundColor: "#441A98",
    ...commonToastStyle
}

const defaultLoadingToastOptions: Partial<ToastOptions> = {
    icon: (
        <img className='animate-spin' src={syncSpinner} alt="loading" width={18} height={18}/>
    )
}

export const commonMessage = (t: Toast, message: string | ReactElement, className?: string) => {
    return (
        <div className='w-full flex items-center'>
            <span className={classNames('grow text-[16px]', className)}>{message}</span>

            <div className="min-w-[18px] ml-4">
                <CloseIcon stroke={'#FFFFFF'}
                           width={18}
                           height={18}
                           role={'button'}
                           onClick={() => toast.dismiss(t.id)}
                />
            </div>
        </div>
    )
}

export const successToast = (message: string | ReactElement, options?: ToastOptions, className?: string) => {
    const {style: customStyle = {}, ...customOptions} = options ?? {};
    return toast((t) => commonMessage(t, message, className), {
        style: {
            ...defaultSuccessToastStyle,
            ...customStyle
        },
        ...defaultSuccessToastOptions,
        ...customOptions,
    })
}

export const infoToast = (message: string | ReactElement, options?: ToastOptions) => {
    const {style: customStyle = {}, ...customOptions} = options ?? {};
    return toast((t) => commonMessage(t, message), {
        style: {
            ...defaultSuccessToastStyle,
            ...customStyle
        },
        ...defaultSuccessToastOptions,
        ...customOptions,
    })
}


export const errorToast = (message: string | ReactElement, options?: ToastOptions) => {
    const {style: customStyle = {}, ...customOptions} = options ?? {};
    return toast((t) => commonMessage(t, message), {
        style: {
            ...defaultErrorToastStyle,
            ...customStyle
        },
        ...defaultErrorToastOptions,
        ...customOptions,
    })
}

export const warningToast = (message: string | ReactElement, options?: ToastOptions) => {
    const {style: customStyle = {}, ...customOptions} = options ?? {};
    return toast((t) => commonMessage(t, message), {
        style: {
            ...defaultWarningToastStyle,
            ...customStyle
        },
        ...defaultWarningToastOptions,
        ...customOptions,
    })
}

export const loadingToast = (message: string | ReactElement, options?: ToastOptions) => {
    const {style: customStyle = {}, ...customOptions} = options ?? {};
    return toast((t) => commonMessage(t, message), {
        style: {
            ...defaultLoadingToastStyle,
            ...customStyle
        },
        ...defaultLoadingToastOptions,
        ...customOptions,
    })
}
